if (!customElements.get('nextbottle-gallery')) {
  customElements.define('nextbottle-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.onSelect) return;
      this.thumbnails = this.querySelector('.nb-gallery-thumbnails');
      if (this.thumbnails) {
        const rail = this.thumbnails;
        this.railWrapper = document.createElement('div');
        this.railWrapper.style.cssText = 'position:relative;padding:0 44px';
        rail.before(this.railWrapper);
        this.railWrapper.append(rail);
        this.scrollControls = document.createElement('div');
        this.scrollControls.setAttribute('role', 'group');
        this.scrollControls.setAttribute('aria-label', 'Bilderleiste verschieben');
        this.scrollControls.style.cssText = 'position:absolute;inset:0;display:flex;justify-content:space-between;pointer-events:none';
        this.scrollButtons = [-1, 1].map(direction => {
          const button = document.createElement('button');
          button.type = 'button';
          const arrow = document.createElement('span');
          arrow.setAttribute('aria-hidden', 'true');
          arrow.style.cssText = 'display:block;width:12px;height:12px;border-top:2px solid currentColor;border-right:2px solid currentColor;transform:rotate(' + (direction < 0 ? '-135deg' : '45deg') + ')';
          button.append(arrow);
          button.setAttribute('aria-label', direction < 0 ? 'Vorherige Vorschaubilder' : 'Weitere Vorschaubilder');
          button.style.cssText = 'display:flex;align-items:center;justify-content:center;flex:0 0 44px;width:44px;min-height:44px;padding:0;border:0;border-radius:0;background:#fff;color:#172c33;cursor:pointer;pointer-events:auto';
          button.addEventListener('click', () => rail.scrollBy({left: direction * Math.max(100, rail.clientWidth * 0.75), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}));
          this.scrollControls.append(button);
          return button;
        });
        this.railWrapper.append(this.scrollControls);
        this.onRailScroll = () => {
          const max = rail.scrollWidth - rail.clientWidth;
          this.scrollControls.style.display = max > 1 ? 'flex' : 'none';
          this.scrollButtons[0].disabled = rail.scrollLeft <= 1;
          this.scrollButtons[1].disabled = rail.scrollLeft >= max - 1;
          this.scrollButtons.forEach(button => { button.style.opacity = button.disabled ? '0' : '1'; button.style.pointerEvents = button.disabled ? 'none' : 'auto'; });
        };
        rail.addEventListener('scroll', this.onRailScroll, {passive:true});
        this.railObserver = new ResizeObserver(this.onRailScroll);
        this.railObserver.observe(rail);
        this.onRailScroll();
      }
      this.updateImage = (image, failed) => {
        if (!image || image.tagName !== 'IMG') return;
        const panel = image.closest('[data-nb-gallery-image]');
        if (!panel || !this.contains(panel)) return;
        const notice = panel.querySelector('[data-nb-gallery-error]');
        if (!notice) return;
        image.hidden = failed;
        notice.hidden = !failed;
        panel.dataset.nbImageFailed = String(failed);
        if (!panel.hidden) this.announce(panel);
      };
      this.onImageError = event => this.updateImage(event.target, true);
      this.onImageLoad = event => this.updateImage(event.target, false);
      this.announce = panel => {
        const panels = Array.from(this.querySelectorAll('[data-nb-gallery-image]'));
        const status = this.querySelector('[data-nb-gallery-status]');
        if (status) status.textContent = `Bild ${panels.indexOf(panel) + 1} von ${panels.length}${panel.dataset.nbImageFailed === 'true' ? ' konnte nicht geladen werden.' : ''}`;
      };
      this.onSelect = event => {
        const button = event.target.closest('[data-nb-gallery-select]');
        if (!button || !this.contains(button)) return;
        const panels = Array.from(this.querySelectorAll('[data-nb-gallery-image]'));
        const selected = panels.find(panel => panel.dataset.nbGalleryImage === button.dataset.nbGallerySelect);
        if (!selected) return;
        panels.forEach(panel => { panel.hidden = panel !== selected; });
        this.querySelectorAll('[data-nb-gallery-select]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.announce(selected);
      };
      this.addEventListener('click', this.onSelect);
      this.addEventListener('error', this.onImageError, true);
      this.addEventListener('load', this.onImageLoad, true);
      this.querySelectorAll('[data-nb-gallery-image] img').forEach(image => {
        if (image.complete) this.updateImage(image, image.naturalWidth === 0);
      });
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onSelect);
      this.removeEventListener('error', this.onImageError, true);
      this.removeEventListener('load', this.onImageLoad, true);
      if (this.thumbnails) this.thumbnails.removeEventListener('scroll', this.onRailScroll);
      if (this.railObserver) this.railObserver.disconnect();
      if (this.scrollControls) this.scrollControls.remove();
      if (this.railWrapper) {
        this.railWrapper.before(this.thumbnails);
        this.railWrapper.remove();
      }
      this.onSelect = null;
    }
  });
}
